// extracted by mini-css-extract-plugin
export default {"full-width-img":"TrainingSummary_full-width-img__SkSRe"};